import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instance37ddoilc7l0w6 as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$default11t6ql2kpbkqz as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instancec5yuwo7wv5k6 as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().p4f("Buffer doesn't contain required number of bytes (size: " + $this.q2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.j4f_1 = null;
        this.k4f_1 = null;
        this.l4f_1 = 0n;
      }
      q2() {
        return this.l4f_1;
      }
      v3v() {
        return this;
      }
      w3v() {
        return this.q2() === 0n;
      }
      x3v(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() < byteCount) {
          throw EOFException().p4f("Buffer doesn't contain required number of bytes (size: " + this.q2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      c3w(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        return this.q2() >= byteCount;
      }
      f3w() {
        var tmp0_elvis_lhs = this.j4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize === 0) {
          this.x4f();
          return this.f3w();
        }
        var v = segment.y4f();
        this.l4f_1 = subtract(this.l4f_1, 1n);
        if (segmentSize === 1) {
          this.x4f();
        }
        return v;
      }
      z4f() {
        var tmp0_elvis_lhs = this.j4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize < 2) {
          this.x3v(2n);
          if (segmentSize === 0) {
            this.x4f();
            return this.z4f();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.f3w() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.f3w() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.a4g();
        this.l4f_1 = subtract(this.l4f_1, 2n);
        if (segmentSize === 2) {
          this.x4f();
        }
        return v;
      }
      b4g() {
        return Unit_instance;
      }
      c4g(out, startIndex, endIndex) {
        checkBounds(this.q2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.l4f_1 = add(out.l4f_1, remainingByteCount);
        var s = this.j4f_1;
        while (currentOffset >= fromInt(ensureNotNull(s).s4f_1 - s.r4f_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.s4f_1 - s.r4f_1 | 0));
          s = s.v4f_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).d4g();
          copy.r4f_1 = copy.r4f_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.r4f_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.s4f_1;
          tmp.s4f_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.j4f_1 == null) {
            out.j4f_1 = copy;
            out.k4f_1 = copy;
          } else if (false) {
            out.k4f_1 = ensureNotNull(out.k4f_1).e4g(copy).f4g();
            if (ensureNotNull(out.k4f_1).w4f_1 == null) {
              out.j4f_1 = out.k4f_1;
            }
          } else {
            out.k4f_1 = ensureNotNull(out.k4f_1).e4g(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.s4f_1 - copy.r4f_1 | 0));
          currentOffset = 0n;
          s = s.v4f_1;
        }
      }
      g4g() {
        var result = this.q2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.k4f_1);
        if (tail.s4f_1 < 8192 && tail.u4f_1) {
          result = subtract(result, fromInt(tail.s4f_1 - tail.r4f_1 | 0));
        }
        return result;
      }
      z3t(position) {
        if (position < 0n || position >= this.q2()) {
          throw IndexOutOfBoundsException().i3('position (' + position.toString() + ') is not within the range [0..size(' + this.q2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.j4f_1).h4g(0);
        }
        $l$block_1: {
          // Inline function 'kotlinx.io.seek' call
          if (this.j4f_1 == null) {
            return ensureNotNull(null).h4g(convertToInt(subtract(position, -1n)));
          }
          if (subtract(this.q2(), position) < position) {
            var s = this.k4f_1;
            var offset = this.q2();
            $l$loop: while (!(s == null) && offset > position) {
              offset = subtract(offset, fromInt(s.s4f_1 - s.r4f_1 | 0));
              if (offset <= position)
                break $l$loop;
              s = s.w4f_1;
            }
            var tmp0 = s;
            var offset_0 = offset;
            return ensureNotNull(tmp0).h4g(convertToInt(subtract(position, offset_0)));
          } else {
            var s_0 = this.j4f_1;
            var offset_1 = 0n;
            $l$loop_0: while (!(s_0 == null)) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.s4f_1 - s_0.r4f_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > position)
                break $l$loop_0;
              s_0 = s_0.v4f_1;
              offset_1 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_2 = offset_1;
            return ensureNotNull(tmp0_1).h4g(convertToInt(subtract(position, offset_2)));
          }
        }
      }
      s4() {
        return this.m3s(this.q2());
      }
      m3s(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.j4f_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().p4f('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.s4f_1 - head.r4f_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$3);
          this.l4f_1 = subtract(this.l4f_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.r4f_1 = head.r4f_1 + toSkip | 0;
          if (head.r4f_1 === head.s4f_1) {
            this.x4f();
          }
        }
      }
      i4g(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.j4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.q2();
        var toCopy = Math.min(tmp0, b);
        s.j4g(sink, startIndex, startIndex + toCopy | 0);
        this.l4f_1 = subtract(this.l4f_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.x4f();
        }
        return toCopy;
      }
      k4g(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.q2() ? this.q2() : byteCount;
        sink.l4g(this, bytesWritten);
        return bytesWritten;
      }
      m4g(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() < byteCount) {
          sink.l4g(this, this.q2());
          throw EOFException().p4f('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.q2().toString() + ' bytes were written.');
        }
        sink.l4g(this, byteCount);
      }
      n4g(sink) {
        var byteCount = this.q2();
        if (byteCount > 0n) {
          sink.l4g(this, byteCount);
        }
        return byteCount;
      }
      x3x() {
        return buffered(new (PeekSource())(this));
      }
      o4g(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.k4f_1 == null) {
          var result = SegmentPool_instance.p3t();
          this.j4f_1 = result;
          this.k4f_1 = result;
          return result;
        }
        var t = ensureNotNull(this.k4f_1);
        if ((t.s4f_1 + minimumCapacity | 0) > 8192 || !t.u4f_1) {
          var newTail = t.e4g(SegmentPool_instance.p3t());
          this.k4f_1 = newTail;
          return newTail;
        }
        return t;
      }
      r4g(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.o4g(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.s4g();
          var toCopy = Math.min(tmp0, b);
          tail.t4g(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.l4f_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.l4f_1 = add(tmp0_0, fromInt(other));
      }
      v4g(source, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var read = source.k4g(this, remainingByteCount);
          if (read === -1n) {
            throw EOFException().p4f('Source exhausted before reading ' + byteCount.toString() + ' bytes. ' + ('Only ' + subtract(byteCount, remainingByteCount).toString() + ' were read.'));
          }
          remainingByteCount = subtract(remainingByteCount, read);
        }
      }
      l4g(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().o2(toString(message));
        }
        checkOffsetAndCount(source.l4f_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.j4f_1).q2())) {
            var tail = this.k4f_1;
            var tmp;
            if (!(tail == null) && tail.u4f_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.s4f_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.w4g() ? 0 : tail.r4f_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.j4f_1).y4g(tail, convertToInt(remainingByteCount));
              source.l4f_1 = subtract(source.l4f_1, remainingByteCount);
              this.l4f_1 = add(this.l4f_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.j4f_1 = ensureNotNull(source.j4f_1).x4g(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.j4f_1);
          var movedByteCount = fromInt(segmentToMove.q2());
          source.j4f_1 = segmentToMove.z4g();
          if (source.j4f_1 == null) {
            source.k4f_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.j4f_1 == null) {
            this.j4f_1 = segmentToMove;
            this.k4f_1 = segmentToMove;
          } else if (true) {
            this.k4f_1 = ensureNotNull(this.k4f_1).e4g(segmentToMove).f4g();
            if (ensureNotNull(this.k4f_1).w4f_1 == null) {
              this.j4f_1 = this.k4f_1;
            }
          } else {
            this.k4f_1 = ensureNotNull(this.k4f_1).e4g(segmentToMove);
          }
          source.l4f_1 = subtract(source.l4f_1, movedByteCount);
          this.l4f_1 = add(this.l4f_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      a4h(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.k4g(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      b4h(byte) {
        this.o4g(1).c4h(byte);
        this.l4f_1 = add(this.l4f_1, 1n);
      }
      d4h(short) {
        this.o4g(2).e4h(short);
        this.l4f_1 = add(this.l4f_1, 2n);
      }
      l6() {
        return Unit_instance;
      }
      toString() {
        if (this.q2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$0 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$0);
        var builder = StringBuilder().ub(imul(len, 2) + (this.q2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.j4f_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.q2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.f4h(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$4 = b_0 >> 4;
            var tmp_0 = builder.o1(tmp[tmp$ret$4 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$5 = b_0 & 15;
            tmp_0.o1(tmp_1[tmp$ret$5]);
          }
          curr = curr.v4f_1;
        }
        if (this.q2() > fromInt(maxPrintableBytes)) {
          builder.o1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.q2().toString() + ' hex=' + builder.toString() + ')';
      }
      x4f() {
        var oldHead = ensureNotNull(this.j4f_1);
        var nextHead = oldHead.v4f_1;
        this.j4f_1 = nextHead;
        if (nextHead == null) {
          this.k4f_1 = null;
        } else {
          nextHead.w4f_1 = null;
        }
        oldHead.v4f_1 = null;
        SegmentPool_instance.g4h(oldHead);
      }
      h4h() {
        var oldTail = ensureNotNull(this.k4f_1);
        var newTail = oldTail.w4f_1;
        this.k4f_1 = newTail;
        if (newTail == null) {
          this.j4f_1 = null;
        } else {
          newTail.v4f_1 = null;
        }
        oldTail.w4f_1 = null;
        SegmentPool_instance.g4h(oldTail);
      }
    }
    protoOf($).u4g = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
